/**
 * The one house timestamp formatter.
 *
 * Standing owner rule: the console never renders a relative timestamp — no
 * "just now", no "5m ago", no "3 hours ago". Every instant shown to a user is
 * absolute via `toLocaleString()`, so the reader can tell exactly when
 * something happened without doing arithmetic against "now" (and without the
 * value going stale the moment it is rendered).
 *
 * Anything that needs to render an instant imports from here. Do not
 * hand-roll another copy in a route or component file.
 */

/** Absolute local timestamp. "—" when absent, the raw value when unparseable. */
export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

/**
 * Absolute local timestamp with a caller-chosen placeholder for absent values.
 * Connector/heartbeat surfaces read better with "Never" than with an em dash.
 */
export function formatTimestampOr(iso: string | null | undefined, absent: string): string {
  if (!iso) return absent;
  return formatTimestamp(iso);
}
